export default ({
    from=false,
    to=false
}) => {
    return (
        <div className="vip-20-benefits-benefit deposit-assist-token">
            <div className="vip-20-benefits-benefit-information">
                <div className="vip-20-benefits-benefit-information-top">
                    <div className="benefit-title">Deposit Assist</div>
                    <div className="benefit-description">Get help covering small gaps in your deposits</div>
                </div>

                <div className="vip-20-benefits-benefit-information-bottom">
                    <div className="benefit-progress">
                        {(from && to) ? (
                            <>
                                <div className="previous">{from}</div>
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.8225 4.44727L15.375 8.99977L10.8225 13.5523" stroke="#DFDFEC" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M2.625 9H15.2475" stroke="#DFDFEC" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                                <div className="next">{to}</div>
                            </>
                        ) : (
                            <>
                                {(!from && to)? (
                                    <div className="next">{to}</div>
                                ) : ''}

                                {(from && !to)? (
                                    <div className="previous">{from}</div>
                                ) : ''}
                            </>
                        )}
                    </div>
                </div>
            </div>
            <div className="vip-20-benefits-benefit-creative">
                <div className="deposit-assist-token-icon"></div>
                <div className="ellipse"></div>
                <div className="bundler"></div>
            </div>
        </div>
    )
}